import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Store from '@apricityhealth/web-common-lib/reduxStore';
const store = Store();

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename="/">
            <App />
        </BrowserRouter>,
    </Provider>,
    document.getElementById('root')
);
